'use client'
import { useEffect, useState } from "react";
const useDetectTouchDevice = ()=>{
    const [isTouchDevice, setIsTouchDevice] = useState(false);
    useEffect(()=>{
        const hasTouchCapability = window && 'ontouchstart' in window;
        const isTouchDevice = hasTouchCapability;
        setIsTouchDevice(isTouchDevice);
    }, []);
    return isTouchDevice;
};
export { useDetectTouchDevice };
